import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AlertComponent({ message, onClose }) {
    return (
        <div className="alert-popup">
            <p>{message}</p>
        </div>
    );
}

const Login = () => {
    const [credentials, setCredentials] = useState({ username: "", password: "" });
    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState(false);
    const [timerDiv, setTimerDiv] = useState(false);

    const handleShowAlert = () => {
        setShowAlert(true);
        const timer = setTimeout(() => {
            setShowAlert(false);
        }, 2000);

        return () => clearTimeout(timer);
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };


    const handleLogin = () => {
        const { username, password } = credentials;
        fetch('https://q7dgkn7hvh.execute-api.us-east-1.amazonaws.com/', {
            method: 'POST',
            body: JSON.stringify({
                Details: {
                    Parameters: {
                        action: 'login',
                        user: credentials.username,
                        pass: credentials.password,
                    }
                }
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.message === 'Success') {
                    localStorage.setItem("auth", JSON.stringify({ username }));
                    navigate("/manager");
                } else {
                    handleShowAlert();
                };
            })
            .catch((error) => {
                // Handle errors
                console.error('Error:', error);
            });
    };

    useEffect(() => {
        const authData = localStorage.getItem("auth");
        if (authData) {
            navigate("/manager");
        }
    }, [navigate]);

    return (
        <div className="background">
            {showAlert && (
                <div className={timerDiv ? "alert-box fade-out" : "alert-box"}>
                    <AlertComponent message="Las credenciales están equivocadas" onClose={handleCloseAlert} />
                </div>
            )}
            <div className="wrapper">
                <div className="container">
                    <div className="col-left">
                        <div className="login-text">
                            <img className="logo" src="/img/ra-logo.png" alt="logo" />
                        </div></div>
                    <div className="col-right">
                        <div className="login-form">
                            <p>Ingresa tus credenciales</p>
                            <p>
                                <input
                                    id="user"
                                    type="text"
                                    placeholder="Usuario"
                                    onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                                /></p>
                            <p>
                                <input
                                    id="pass"
                                    type="password"
                                    placeholder="Contraseña"
                                    onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                                /></p>
                            <button className="btn" onClick={handleLogin}>Ingresar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;